export default __webpack_public_path__ + "static/media/mobile_login_image_en.4bfeb0da.png";